import i18next from 'i18next';
import { type Id, toast } from 'react-toastify';

const sessionIdleWarningId = 'session-idle-warning';

export const notificationSuccess = (message: string) =>
  toast.success(message, {
    toastId: message,
    autoClose: 5000,
    hideProgressBar: true
  });

export const showSessionIdleWarning = (): Id => {
  toast.warn(i18next.t('common.messages.warningInactiveSession'), {
    toastId: sessionIdleWarningId,
    autoClose: false
  });

  return sessionIdleWarningId;
};

export const dismissSessionIdleWarning = (id: Id): void => {
  toast.dismiss(id);
};
